import React, { useState } from 'react'
import PropTypes from 'prop-types';
import DropDownOption from './DropDownOption'
import { popoverIds } from '../savedAgents/helpers'
import { popoverTerms } from '../../constants/agentProductionConstants'
import { agentProductionTerms as apt, buttonTerms } from '../../../constants';
import Display from './Display';
import GrowthAnalysisPeriodDropdown from './GrowthAnalysisPeriodDropdown';
import { views } from '../../constants/savedAgents';
import { HelixIcon } from '@lwt-helix/helix-icon';
import MetricsSelector from '../MetricsSelector';
import { columns, inbox } from '@lwt-helix/helix-icon/outlined';
import { getHeaderText } from '../../helpers/listingProficiencyHelpers';
import { Button } from '@lwt-helix/buttons';
import { setStateData } from '../../../common/helpers/state';
import { useSavedAgentsStore } from '../../../store/store';

export const SavedAgentsActions = (props) => {
    const {
        currentColumns,
        currentSearchDates,
        growthAnalysisPeriod,
        handleShowHideChange,
        isPeriodLast12Months,
        selectedAgentsView,
        className,
        setColumns,
        setGrowthAnalysisPeriod,
        exportCsv
    } = props;

    const {selectedView} = useSavedAgentsStore(state=>({selectedView: state.selectedView}));
    const [ state, setState ] = useState({
        showDisplayPopover: false,
        showMetricsPopover: false,
    });

    const togglePopover = (stateToSet) => setStateData(stateToSet, !state[stateToSet], setState);

    return (
        <div className='d-flex justify-content-center align-items-center px-2'>
            <DropDownOption
                dataLwtId={popoverIds.display}
                popoverInnerClassName='popover-menu-width-224'
                popoverPlacement={popoverTerms.bottomEnd}
                popoverIsOpen={state.showDisplayPopover}
                togglePopover={() => togglePopover('showDisplayPopover')}
                mainTitle={apt[selectedView.value]}
                popoverBody={<Display
                                handleShowHideChange={handleShowHideChange}
                                selectedAgentsView={selectedAgentsView}
                                togglePopover={() => togglePopover('showDisplayPopover')} />}
            />
            {selectedView.value === views.growthAnalysis &&
                <GrowthAnalysisPeriodDropdown
                    growthAnalysisPeriod={growthAnalysisPeriod}
                    setGrowthAnalysisPeriod={setGrowthAnalysisPeriod} />}
            {selectedView.value !== views.activity &&
                <DropDownOption
                    dataLwtId={popoverIds.metrics}
                    popoverInnerClassName='popover-menu-width-800 helix-heading'
                    popoverPlacement={popoverTerms.bottomEnd}
                    popoverIsOpen={state.showMetricsPopover}
                    popoverClassName={className}
                    popoverHeader={selectedView.value === views.listingProficiency ? getHeaderText() : null}
                    togglePopover={() => togglePopover('showMetricsPopover')}
                    mainTitle={<HelixIcon icon={columns} className='mr-2' />}
                    popoverBody={<MetricsSelector
                                    columns={currentColumns}
                                    customSettings={{currentSearchDates, isPeriodLast12Months}}
                                    setColumns={setColumns}
                                    tabMode={selectedView.value} />}
                />}
            <Button
                color='secondary'
                dataLwtId='agents-download-btn'
                id='agents-download-btn'
                size='sm'
                onClick={exportCsv}
            >
                <div className='d-flex align-items-center'>
                    <HelixIcon icon={inbox} className='mr-2' />
                    <span className='text-capitalize'>
                        {buttonTerms.download}
                    </span>
                </div>
            </Button>
        </div>
    )
};

SavedAgentsActions.propTypes = {
    currentColumns: PropTypes.array.isRequired,
    currentSearchDates: PropTypes.object.isRequired,
    growthAnalysisPeriod: PropTypes.string.isRequired,
    handleShowHideChange: PropTypes.func.isRequired,
    isPeriodLast12Months: PropTypes.bool.isRequired,
    selectedAgentsView: PropTypes.string.isRequired,
    setColumns: PropTypes.func.isRequired,
    setGrowthAnalysisPeriod: PropTypes.func.isRequired,
    exportCsv: PropTypes.func.isRequired,
    className: PropTypes.string
};
